import axios from '../axiosCall'
import Urls from "../endpoints";


export const getAllService = () => {
    return axios.get(Urls.GetAllService())
}

export const postCustomer = (file) => {
    var bodyFormData = new FormData();
    bodyFormData.append('excel', file); 
    return axios.post(Urls.PostCustomer(), bodyFormData,{headers: { "Content-Type": "multipart/form-data" }})
}

export const postInvoice = (model) => {
    return axios.post(Urls.PostInvoice(), model)
}